module.exports = __webpack_public_path__ + "img/barcode.2ae4a7a1.png";